<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6029 2C19.6029 2 21.1691 2.53879 22.3015 3.61638C23.4338 4.69397 24 6.18103 24 8.07759C24 9.37069 23.5294 10.6925 22.5882 12.0431C22.1176 12.7328 21.5735 13.3649 20.9559 13.9397L12.7059 21.7414C12.5 21.9138 12.2647 22 12 22C11.7353 22 11.5 21.9138 11.2941 21.7414L3.04412 13.9397C2.54412 13.5086 2.02941 12.9195 1.5 12.1724C0.5 10.7644 0 9.39943 0 8.07759C0 6.18103 0.566176 4.69397 1.69853 3.61638C2.83088 2.53879 4.39706 2 6.39706 2C7.42647 2 8.51471 2.34483 9.66177 3.03448C10.4559 3.49425 11.2353 4.08333 12 4.80172C12.7647 4.08333 13.5441 3.49425 14.3382 3.03448C15.4853 2.34483 16.5735 2 17.6029 2Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HeartIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
